import React from 'react'

import { SetupBlockedBanner } from '@/views/Organizations/components/SetupBlockedBanner'
import {
  SHAREPOINT_SITE_ACCESS_GUIDE_URL,
  adminConsentUrl,
} from '@/views/Organizations/components/SharePointConnectionForm.helpers'

/**
 * Tells the customer their Microsoft admin has not approved the Balto SharePoint app, and
 * gives them the link to send that admin and the guide to the per-site read access step.
 *
 * @param {string} props.tenantId the connection's Entra tenant GUID
 */
export const AdminApprovalBanner = ({ tenantId }) => (
  <SetupBlockedBanner
    data-testid="sharepoint-admin-approval-banner"
    heading="Waiting for admin approval"
    links={[
      { url: adminConsentUrl(tenantId), label: 'Approval link for your Microsoft admin' },
      {
        url: SHAREPOINT_SITE_ACCESS_GUIDE_URL,
        label: 'How to give Balto read access to each site',
      },
    ]}
  >
    Nothing from SharePoint can sync until a Global Administrator in your Microsoft account approves
    the Balto SharePoint Integration app. Send them this link. Syncing starts on its own within 15
    minutes of approval, once each site below has also given Balto read access.
  </SetupBlockedBanner>
)
